import { Tefl } from '../../../lib/types/models/tefl/tefl'
import { TeflInput } from '../../../lib/types/models/tefl/tefl-input'

export const mapTeflToInput = (tefl: Tefl): TeflInput => {
  return {
    ableToTeachInAnotherArea: tefl.ableToTeachInAnotherArea ?? false,
    address1: tefl.address1,
    address2: tefl.address2,
    city: tefl.city,
    country: tefl.country,
    birthDate: tefl.birthDate,
    email: tefl.email,
    firstName: tefl.firstName,
    car: tefl.car,
    drivingLicense: tefl.drivingLicense,
    gender: tefl.gender,
    firstYearOfTeaching: tefl.firstYearOfTeaching,
    lastName: tefl.lastName,
    mostLevelTaught: tefl.mostLevelTaught,
    motherTongue: tefl.motherTongue,
    nationality: tefl.nationality,
    phoneNumber: tefl.phoneNumber,
    postalCode: tefl.postalCode,
    comments: tefl.comments,
    fieldOfExpertise: tefl.fieldOfExpertise,
    diplomas: tefl.diplomas.map(({ id: _id, ...diploma }) => diploma),
    documents: tefl.documents.map(({ id: _id, ...document }) => document)
  }
}
